module.exports = __webpack_public_path__ + "static/media/promo-image.1e9a4624.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/promo-image.jpg
// module id = 108
// module chunks = 0